import { I as Icon, _ as _extends } from './Icon-BnBRpux5.js';
import React, { forwardRef } from 'react';
import '@emotion/is-prop-valid';
import '@indeed/ifl-css';
import '@emotion/react';
import './IconProvider.js';

const Jobs = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    fill = "currentColor",
    size = "md",
    variant,
    ...remainingProps
  } = _ref;
  const paths = {
    filled: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
      d: "M4 21c-.55 0-1.0208-.1958-1.4125-.5875C2.1958 20.0208 2 19.55 2 19v-7h8c0 1.1046.8954 2 2 2s2-.8954 2-2h8v7c0 .55-.1958 1.0208-.5875 1.4125C21.0208 20.8042 20.55 21 20 21H4z"
    }), /*#__PURE__*/React.createElement("path", {
      fillRule: "evenodd",
      d: "M2 10V8c0-.55.1958-1.0208.5875-1.4125C2.9792 6.1958 3.45 6 4 6h4V4c0-.55.1958-1.0208.5875-1.4125C8.9792 2.1958 9.45 2 10 2h4c.55 0 1.0208.1958 1.4125.5875C15.8042 2.9792 16 3.45 16 4v2h4c.55 0 1.0208.1958 1.4125.5875C21.8042 6.9792 22 7.45 22 8v2H2zm8-4h4V4h-4v2z",
      clipRule: "evenodd"
    })),
    stroke: /*#__PURE__*/React.createElement("path", {
      fillRule: "evenodd",
      d: "M2.5875 20.4125C2.9792 20.8042 3.45 21 4 21h16c.55 0 1.0208-.1958 1.4125-.5875C21.8042 20.0208 22 19.55 22 19V8c0-.55-.1958-1.0208-.5875-1.4125C21.0208 6.1958 20.55 6 20 6h-4V4c0-.55-.1958-1.0208-.5875-1.4125C15.0208 2.1958 14.55 2 14 2h-4c-.55 0-1.0208.1958-1.4125.5875C8.1958 2.9792 8 3.45 8 4v2H4c-.55 0-1.0208.1958-1.4125.5875C2.1958 6.9792 2 7.45 2 8v11c0 .55.1958 1.0208.5875 1.4125zM20 10V8H4v2h16zM4 12v7h16v-7h-6c0 1.1046-.8954 2-2 2s-2-.8954-2-2H4zm10-6h-4V4h4v2z",
      clipRule: "evenodd"
    }),
    strokertl: /*#__PURE__*/React.createElement("path", {
      fillRule: "evenodd",
      d: "M2.5875 20.4125C2.9792 20.8042 3.45 21 4 21h16c.55 0 1.0208-.1958 1.4125-.5875C21.8042 20.0208 22 19.55 22 19V8c0-.55-.1958-1.0208-.5875-1.4125C21.0208 6.1958 20.55 6 20 6h-4V4c0-.55-.1958-1.0208-.5875-1.4125C15.0208 2.1958 14.55 2 14 2h-4c-.55 0-1.0208.1958-1.4125.5875C8.1958 2.9792 8 3.45 8 4v2H4c-.55 0-1.0208.1958-1.4125.5875C2.1958 6.9792 2 7.45 2 8v11c0 .55.1958 1.0208.5875 1.4125zM20 10V8H4v2h16zM4 12v7h16v-7h-6c0 1.1046-.8954 2-2 2s-2-.8954-2-2H4zm10-6h-4V4h4v2z",
      clipRule: "evenodd"
    })
  };
  return /*#__PURE__*/React.createElement(Icon, _extends({
    ref: ref,
    fill: fill,
    paths: paths,
    size: size,
    variant: variant
  }, remainingProps));
});
Jobs.displayName = "JobsIcon";

export { Jobs, Jobs as default };
